import type { LocalPaymentMethod } from "../../../types/lifecycle.ts";

/** How the client paid an installment; the backend records it in VALIORS.DIV_ID. */
export const PAYMENT_METHODS: Record<LocalPaymentMethod, string> = {
  cash: "В брой",
  card: "С карта (POS)",
  "bank-transfer": "По банков път",
};
